import { useState, useCallback } from 'react';
import { fetchLeadsByName } from '@/services/api/leads';
import { useDebounceSearch } from './useDebounceSearch';

interface LeadSearchResult {
  id: number;
  name: string;
  company?: string;
  industry?: string;
}

export const useEnhancedLeadSearch = () => {
  const [leads, setLeads] = useState<LeadSearchResult[]>([]);
  const [loading, setLoading] = useState(false);

  const performSearch = useCallback(async (name: string) => {
    if (name.length < 2) {
      setLeads([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      console.log('🔍 Searching leads for:', name);
      const response = await fetchLeadsByName(name);
      const leadsData = Array.isArray(response) ? response : [];
      const formattedLeads = leadsData.map(lead => ({
        id: lead.id || 0,
        name: lead.name || lead.company_name || '',
        company: lead.company_name || lead.name || '',
        industry: lead.industry || ''
      }));
      console.log('✅ Lead search results:', formattedLeads);
      setLeads(formattedLeads);
    } catch (error) {
      console.error('💥 Error searching leads:', error);
      setLeads([]);
    } finally {
      setLoading(false);
    }
  }, []);

  return { leads, loading, searchLeads: performSearch };
};